import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

export type TextareaSize = 'sm' | 'md' | 'lg';
export type TextareaFontStyle = 'default' | 'serif-italic';

@Component({
  selector: 'om-textarea',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './textarea.html',
  styleUrl: './textarea.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Textarea {
  /** FormControl bound to the native textarea. */
  control = input.required<FormControl>();

  /** Placeholder text. */
  placeholder = input<string>('');

  /** HTML id attribute. */
  inputId = input<string>('');

  /** Number of visible text rows. */
  rows = input<number>(4);

  /** Visual size variant. */
  size = input<TextareaSize>('md');

  /**
   * Font style variant.
   * - `default`: standard sans-serif input style.
   * - `serif-italic`: Merriweather italic — for letter/carta fields.
   */
  fontStyle = input<TextareaFontStyle>('default');

  /** Maximum character count (shown in counter when > 0). */
  maxLength = input<number>(0);

  /** Whether to show the built-in character counter. Defaults to true. */
  showCounter = input<boolean>(true);

  /** CSS classes combining size and font style variants. */
  sizeClass = computed(
    () => `om-textarea--${this.size()} om-textarea--${this.fontStyle()}`
  );
}
